import dayjs from 'dayjs'
import ja from 'dayjs/locale/ja'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault('Asia/Tokyo')
dayjs.locale(ja)

export const getAreaPrefectureName = (key) => {
  const areaItem = areaToPrefTable.find((item) => item.key === key)
  if (areaItem) {
    return areaItem.name
  }
  for (const area of areaToPrefTable) {
    const pref = area.pref_list.find((pref) => pref.key === key)
    if (pref) {
      return pref.name
    }
  }
  return null
}

export const getAreaCategory = (key) => {
  if (areaToPrefTable.some((item) => item.key === key)) {
    if (key === 'okinawa') {
      return 'pref'
    }
    return 'area'
  }
  for (const area of areaToPrefTable) {
    const pref = area.pref_list.find((pref) => pref.key === key)
    if (pref) {
      return 'pref'
    }
  }
  return null
}

export const getAreaByPrefKey = (prefKey) => {
  if (prefKey === 'okinawa') {
    return { key: 'okinawa', name: '沖縄県' }
  }
  for (const area of areaToPrefTable) {
    if (area.pref_list.some((pref) => pref.key === prefKey)) {
      return { key: area.key, name: area.name }
    }
  }
  return null
}

const HOKKAIDO_REGIONS = new Set(['douou', 'doutou', 'dounan', 'douhoku'])

export const getThumbnailPath = (prefKey) => {
  if (prefKey === 'okinawa') {
    return '/okinawa/'
  }
  if (HOKKAIDO_REGIONS.has(prefKey)) {
    return '/hokkaido/'
  }
  for (const area of areaToPrefTable) {
    for (const pref of area.pref_list) {
      if (pref.key === prefKey) {
        return `/${area.key}/${prefKey}/`
      }
    }
  }
  return '/'
}

export const getFullPrefectureName = (prefKey, type = null) => {
  const specialPrefectures = {
    東京: '都',
    大阪: '府',
    京都: '府'
  }
  if (areaToPrefTable.some((item) => item.key === prefKey)) {
    if (prefKey === 'okinawa') {
      return '沖縄県'
    }
    return `${areaToPrefTable.find((item) => item.key === prefKey).name}`
  }
  for (const area of areaToPrefTable) {
    const pref = area.pref_list.find((pref) => pref.key === prefKey)
    if (pref) {
      if (pref.name in specialPrefectures) {
        return `${pref.name}${specialPrefectures[pref.name]}`
      }
      if (HOKKAIDO_REGIONS.has(pref.key)) {
        if (type === 'area') {
          return '北海道'
        }
        return pref.name
      }
      return `${pref.name}県`
    }
  }
  return null
}

export const createRadarLink = (weather, currentPath) => {
  const firstParam = currentPath.split('/').find(Boolean)
  if (weather === 'wind') {
    if (areaToPrefTable.some((item) => item.key === firstParam)) {
      return `/onebox/${weather}${currentPath}`
    } else {
      for (const area of areaToPrefTable) {
        const pref = area.pref_list.find((pref) => pref.key === firstParam)
        if (pref) {
          return `/onebox/${weather}/${area.key}${currentPath}`
        }
      }
    }
    return `/onebox/${weather}${currentPath}`
  }
  return `/onebox/${weather}${currentPath}`
}
